import { API_BASE_URL } from "../config/apiBaseUrl.js";
import { clientPortalRequest, buildClientQuery } from "./clientPortalFetch";

export function listClientOpportunities(clientViewId, params = {}) {
  return clientPortalRequest(
    `/views/${clientViewId}/opportunities${buildClientQuery(params)}`
  );
}

export function getClientOpportunity(clientViewId, opportunityId) {
  return clientPortalRequest(`/views/${clientViewId}/opportunities/${opportunityId}`);
}

export function updateClientOpportunityStatus(clientViewId, opportunityId, { status, note }) {
  return clientPortalRequest(`/views/${clientViewId}/opportunities/${opportunityId}/status`, {
    method: "PATCH",
    body: JSON.stringify({ status, note }),
  });
}

export function addClientOpportunityNote(clientViewId, opportunityId, { note, subject }) {
  return clientPortalRequest(`/views/${clientViewId}/opportunities/${opportunityId}/notes`, {
    method: "POST",
    body: JSON.stringify({ note, subject }),
  });
}

export function updateClientOpportunityFollowUp(clientViewId, opportunityId, nextFollowUpAt) {
  return clientPortalRequest(`/views/${clientViewId}/opportunities/${opportunityId}/follow-up`, {
    method: "PATCH",
    body: JSON.stringify({ nextFollowUpAt }),
  });
}

export function updateClientOpportunity(clientViewId, opportunityId, payload) {
  return clientPortalRequest(`/views/${clientViewId}/opportunities/${opportunityId}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export function updateClientOpportunityAssignments(
  clientViewId,
  opportunityId,
  { vendorId, assignedClientUserId }
) {
  return clientPortalRequest(`/views/${clientViewId}/opportunities/${opportunityId}/assignments`, {
    method: "PATCH",
    body: JSON.stringify({ vendorId, assignedClientUserId }),
  });
}

export function getClientOpportunitiesExportUrl(clientViewId, params = {}) {
  return `${API_BASE_URL}/api/client/views/${clientViewId}/opportunities/export${buildClientQuery(params)}`;
}
